import * as yup from 'yup'

const releaseNoteFormValidationSchema = yup
  .object({
    title: yup
      .string()
      .trim()
      .required('Title is required')
      .min(3, 'Title should contain at least ${min} characters')
      .max(255, 'Title should not contain more than ${max} characters'),
    body: yup
      .string()
      .trim()
      .required('Body is required')
      .min(3, 'Body should contain at least ${min} characters')
      .max(99999, 'Body should not contain more than ${max} characters')
  })
  .required()

export default releaseNoteFormValidationSchema
